export default __webpack_public_path__ + "static/media/home.19e6cbba.svg";